import PropTypes from 'prop-types'

export const viewingRoomDataType = PropTypes.shape({
    vrKey: PropTypes.string,
    hideVrIcon: PropTypes.bool,
    url: PropTypes.string
})
